module.exports = __webpack_public_path__ + "img/2b59b18.jpg";